import { filterSpecSchema, EMPTY_FILTER } from '../domain/schemas';
import type { FilterSpec } from '../domain/types';

const ARRAY_KEYS = ['mode', 'characters', 'builds', 'ascensions', 'outcomes', 'includeCards', 'excludeCards', 'includeRelics', 'excludeRelics'] as const;

export function parseFilterFromSearch(search: string): FilterSpec {
  const params = new URLSearchParams(search);
  const raw: Record<string, unknown> = { ...EMPTY_FILTER };
  for (const key of ARRAY_KEYS) {
    const value = params.get(key);
    if (!value) continue;
    raw[key] = key === 'ascensions' ? value.split(',').map(Number).filter(Number.isFinite) : value.split(',').filter(Boolean);
  }
  if (params.has('party')) raw.party = params.get('party');
  if (params.has('from')) raw.dateFrom = params.get('from');
  if (params.has('to')) raw.dateTo = params.get('to');
  if (params.has('minTime')) raw.minDuration = Number(params.get('minTime')) || null;
  if (params.has('maxTime')) raw.maxDuration = Number(params.get('maxTime')) || null;
  const parsed = filterSpecSchema.safeParse(raw);
  return parsed.success ? parsed.data : { ...EMPTY_FILTER };
}

export function serializeFilterToSearch(filter: FilterSpec, existing = ''): string {
  const params = new URLSearchParams(existing);
  for (const key of ARRAY_KEYS) {
    const values = filter[key];
    if (values.length) params.set(key, values.join(','));
    else params.delete(key);
  }
  if (filter.party !== 'all') params.set('party', filter.party); else params.delete('party');
  if (filter.dateFrom) params.set('from', filter.dateFrom); else params.delete('from');
  if (filter.dateTo) params.set('to', filter.dateTo); else params.delete('to');
  if (filter.minDuration !== null) params.set('minTime', String(filter.minDuration)); else params.delete('minTime');
  if (filter.maxDuration !== null) params.set('maxTime', String(filter.maxDuration)); else params.delete('maxTime');
  const value = params.toString();
  return value ? `?${value}` : '';
}

export function filterCount(filter: FilterSpec): number {
  return filter.mode.length + filter.characters.length + filter.builds.length + filter.ascensions.length + filter.outcomes.length +
    filter.includeCards.length + filter.excludeCards.length + filter.includeRelics.length + filter.excludeRelics.length +
    Number(filter.party !== 'all') + Number(Boolean(filter.dateFrom)) + Number(Boolean(filter.dateTo)) +
    Number(filter.minDuration !== null) + Number(filter.maxDuration !== null);
}
